import { all, fork } from 'redux-saga/effects';
import { listTenantsSaga } from './list-tenant';
import { selectTenantSaga } from './select-tenant';
export function* rootSaga() {
    yield all([fork(listTenantsSaga), fork(selectTenantSaga)]);
}
